import './index.styl'
import React from 'react'
import { Route } from 'react-router'
import Navbar from '../../containers/Navbar'

class App extends React.Component {
  constructor (props) {
    super(props)
  }

  componentWillMount () {
    const { auth, authStatus, actions } = this.props

    if (authStatus === 'pending' && auth.isLoggedIn === false) {
      this.triggerLogin()
      return
    }
  }

  componentWillUpdate (nextProps) {
    const { auth, authStatus, actions, me } = nextProps

    if (authStatus === 'login-in-progress' && auth.isLoggedIn === true) {
      actions.loginSuccess()
      return
    }

    if (authStatus === 'login-in-progress' && auth.error !== null && auth.isLoggedIn === false) {
      actions.loginFailed()
      return
    }

    if (authStatus === 'login-success' && auth.token !== null && me === null) {
      actions.fetchMe(auth.token)
      return
    }
  }

  triggerLogout () {
    const {actions} = this.props
    actions.loginLoggedOut()
    actions.logout()
  }

  triggerLogin () {
    const {actions} = this.props
    actions.loginInProgress()
    actions.login()
  }

  render () {
    const { authStatus, auth } = this.props

    if (auth.isLoggedIn === false) {
      let status = 'Niet ingelogd'

      if (authStatus === 'pending' || authStatus === 'login-in-progress') {
        status = 'Momentje...'
      }

      return (
        <main>
          <section className="container align-center">
            <h1 className="margin-top">{status}</h1>
          </section>
        </main>
      )
    }

    return (
      <main>
        <Navbar />
        {this.props.children}
      </main>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./components/App/index.js